<template>
    <transition name="slideleft" mode="out-in" appear>
        <div class="tab relative" v-if="!recreate || active" v-show="active">
            <slot :v-bind="$props"></slot>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'tab',
    props: {
        text: String,
        // route name
        route: String,
        recreate: {
            type: Boolean,
            default: false
        },
        data: Object
    },
    data: () => ({
        active: false
    }),
    methods: {
        setActive() {
            this.active = true
            this.$emit('focus')
        },
        setInactive() {
            if (this.active == true) {
                this.$emit('blur')
            }
            this.active = false
        }
    }
}
</script>
